class WImarqueetext extends HTMLElement {
    constructor() {
        super();
        this.animations = [];
    }

    connectedCallback() {
        this.scrollAnim();
    }

    scrollAnim() {
        let toBescrollDiv = this.querySelectorAll('.toBeScroll');
        let speed = Number(this.getAttribute('data-speed')) * 1000;
        let direction = this.getAttribute('data-direction');

        toBescrollDiv.forEach(elem => {
            let offWidth = elem.offsetWidth;

            const animation = elem.animate([{ transform: 'translate(0)' },{transform: direction === 'right' ? `translate(${offWidth}px)`: `translate(-${offWidth}px)`}],{duration: speed,iterations: Infinity,easing: 'linear'}
            );

            this.animations.push(animation);
        });

       if (this.getAttribute('data-onhover') === 'true') {
    this.addEventListener('mouseenter', () => {
        this.animations.forEach(animation => animation.pause());
    });

    this.addEventListener('mouseleave', () => {
        this.animations.forEach(animation => animation.play());
    });
}
    }
}

customElements.define('wi-marqueetext', WImarqueetext);